import React, { createContext, ReactNode, useCallback, useState } from 'react'
import jwt_decode from 'jwt-decode'
import { useApolloClient } from '@apollo/client'
import * as Sentry from '@sentry/browser'
import { Personne, User } from '../types'

interface Utilisateur extends User {
  personne: Personne
  iat: number
  ext: number
  'https://hasura.io/jwt/claims': {
    'x-hasura-allowed-roles': Array<string>
    'x-hasura-default-role': string
    'x-hasura-user-id': string
  }
}

export const AuthContext = createContext<Auth>({} as Auth)

export const ProvideAuth = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<Utilisateur | null>(null)
  const client = useApolloClient()

  const signin = useCallback((token: string, cb?: Function) => {
    const user: Utilisateur = jwt_decode(token)
    window.localStorage.setItem('jwt', token)
    setUser(user)
    Sentry.setUser({ id: user.personne.id.toString(), username: `${user.personne.nom} ${user.personne.prenom}` })
    cb?.()
  }, [])

  const signout = (cb?: Function) => {
    client.clearStore()
    window.localStorage.removeItem('jwt')
    setUser(null)
    Sentry.configureScope((scope) => scope.setUser(null))
    cb?.()
  }

  // TODO: modifier ce fonctionnement
  const jwt = window.localStorage.getItem('jwt')
  if (jwt && !user) {
    signin(jwt)
  }
  const value = { user, signin, signout }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
